import {createStrokeSVG} from './TEMPLATE'

// tabler: sparkle
export const Sparkle_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M21 12c-6.597 0 -9 2.403 -9 9c0 -6.597 -2.403 -9 -9 -9c6.597 0 9 -2.403 9 -9c0 6.597 2.403 9 9 9',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
